/**
 * ETMF Overview - Actions Menu Wrapper
 *
 * Migrated from: lego/page/etmf/overview/generate-study/ActionsMenuWrapper.jsx
 *
 * Provides role-based action menu for ETMF Overview page:
 * - Generate New Study Structure
 * - Update Study Structure
 * - Upload and File (skipped in initial implementation)
 */

import React from 'react'
import { useServiceContext } from '../../../root'
import { useModal } from '../../../contexts/ModalContext'
import ActionsMenuBig from '../../../components/shared/ActionsMenuBig'
import { USER_ROLE } from '../../../constants/user'
import GenerateStudyDialog from './generate-study/Dialog'
import UpdateStudyDialog from './update-study/Dialog'
import { useNavigate } from 'react-router'

/**
 * ActionsMenuWrapper Component
 *
 * Role-based filtering:
 * - ETMF_SPONSOR: No menu displayed
 * - ADMIN/ETMF_MANAGER/CONTENT_ADMIN: Show Generate & Update actions
 * - ETMF_SPECIALIST: Show only Upload action (not implemented yet)
 */
const ActionsMenuWrapper: React.FC = () => {
  const context = useServiceContext()
  const { showModal } = useModal()
  const { auth } = context.service
  const { translate } = context.service.filter
  const navigate = useNavigate()

  const USER_ROLE_CURRENT = auth.getRole()

  const uploadAndFileActionItem = {
    value: translate('UPLOAD_AND_FILE_ACTION_ITEM'),
    action: () => {
      navigate('/upload-and-file')
    }
  }

  // Don't show menu if no role or ETMF_SPONSOR role
  if (!USER_ROLE_CURRENT || USER_ROLE_CURRENT === USER_ROLE.ETMF_SPONSOR) {
    return null
  }

  // Define menu actions
  const handleGenerateStudy = () => {
    showModal(<GenerateStudyDialog onClose={() => {}} />)
  }

  const handleUpdateStudy = () => {
    showModal(<UpdateStudyDialog onClose={() => {}} />)
  }

  const handleUploadAndFile = () => {
    // TODO: Navigate to upload and file page
    // context.service.$state?.go('app.uploadAndFile')
    console.log('Upload and File action - To be implemented')
  }

  // Menu configuration based on role
  const getMenuItems = () => {
    const items = []

    // Generate and Update actions for ADMIN, ETMF_MANAGER, CONTENT_ADMIN
    if ([USER_ROLE.ADMIN, USER_ROLE.ETMF_MANAGER, USER_ROLE.CONTENT_ADMIN].includes(USER_ROLE_CURRENT)) {
      items.push(
        ...[
          uploadAndFileActionItem,
          {
            value: translate('ETMF_ACTION_GENERATE_NEW_STUDY_STRUCTURE'),
            action: handleGenerateStudy
          }
        ]
      )

      items.push({
        value: translate('ETMF_ACTION_UPDATE_STUDY_STRUCTURE'),
        action: handleUpdateStudy
      })
    }

    return items
  }

  const menuItems = getMenuItems()

  // Don't render menu if no items
  if (menuItems.length === 0) {
    return null
  }

  return (
    <div className="theme-sandman">
      <ActionsMenuBig menuId="etmf-overview-page-actions" items={menuItems} />
    </div>
  )
}

export default ActionsMenuWrapper
